export default "__VITE_PUBLIC_ASSET__641b7316__"